function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var RedSquareMainTemplate = require('./main.template');
var Tweet = require('./tweet');
var Post = require('./post');
var Notification = require('./notification');
var SaitoProfile = require('./../../../lib/saito/ui/saito-profile/saito-profile');
var SaitoLoader = require('./../../../lib/saito/ui/saito-loader/saito-loader');

//
// RedSquare Main
//
//
var RedSquareMain = /*#__PURE__*/function () {
  function RedSquareMain(app, mod) {
    var _this = this;
    _classCallCheck(this, RedSquareMain);
    this.app = app;
    this.mod = mod;
    this.name = 'RedSquareMain';
    this.mode = 'welcome';
    this.components = {};
    this.scroll_depth = 0;
    this.profile_tweets = {};
    this.profile = new SaitoProfile(app, mod, '.saito-main');
    this.profile.tab_container = '.tweet-container';
    this.profile_tabs = ['posts', 'replies', /*'retweets',*/'likes'];
    this.profile.reset(this.mod.publicKey, 'posts', this.profile_tabs);

    //This is an in-place loader... not super useful when content is overflowing off the bottom of the screen
    this.loader = new SaitoLoader(app, mod, '#redsquare-intersection');

    ///////////////////
    // RENDER EVENTS //
    ///////////////////
    //
    // lib/main.js:    this.app.connection.on("redsquare-home-render-request", () => {          // renders main tweets
    // lib/main.js:    this.app.connection.on("redsquare-home-postcache-render-request", () => {        // pushes new content into feed if possible
    // lib/main.js:    this.app.connection.on("redsquare-tweet-render-request", (tweet) => {      // renders tweet onto page, at bottom
    // lib/main.js:    this.app.connection.on("redsquare-profile-render-request", () => {         // renders profile
    // lib/main.js:    this.app.connection.on("redsquare-notifications-render-request", () => {     // renders notifications
    // lib/main.js:    app.connection.on('redsquare-render-new-post', ()=> // insert a newly posted tweet in the feed
    //

    app.connection.on('redsquare-render-new-post', function (tweettx) {
      var rparent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!_this.mode.includes('tweet')) {
        return;
      }
      var posted_tweet = new Tweet(_this.app, _this.mod, tweettx, '.tweet-container');
      if (rparent) {
        if (posted_tweet.retweet_tx) {
          rparent.render();
          _this.mod.addTweet(tweettx, {
            type: 'retweet',
            node: 'user post'
          });
          posted_tweet.render(true);
        } else {
          _this.mod.addTweet(tweettx, {
            type: 'reply',
            node: 'user post'
          });
          if (rparent.parent_id != '') {
            var t = _this.mod.returnTweet(rparent.parent_id);
            if (t) {
              t.critical_child = posted_tweet;
            }
          }
          rparent.critical_child = posted_tweet;
          rparent.forceRenderWithCriticalChild();
        }
      } else {
        _this.mod.addTweet(tweettx, {
          type: 'new tweet',
          node: 'user post'
        });
        posted_tweet.render(true);
      }
    });
    app.connection.on('redsquare-home-render-request', function () {
      var scroll_to_top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      console.debug('RS.redsquare-home-render-request', scroll_to_top);
      var behavior = scroll_to_top ? 'smooth' : 'auto';
      if (scroll_to_top) {
        _this.scroll_depth = 0;
        window.history.replaceState({}, null, '/' + _this.mod.slug);
      } else {
        window.history.pushState({}, null, '/' + _this.mod.slug);
      }
      if (_this.mod.out_of_order) {
        console.info('RS.home-render-request have new tweets the fold into feed, rerender!');
        _this.clearFeed();
      }
      _this.render();
    });

    //
    // render main (subsequent loads)
    //
    app.connection.on('redsquare-home-postcache-render-request', function () {
      var num_tweets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (num_tweets > 0 && _this.mode === 'tweets') {
        var are_there_new_tweets_to_show = false;
        for (var i = 0; i < _this.mod.tweets.length && i < 10; i++) {
          if (!_this.mod.tweets[i].isRendered()) {
            if (!_this.mod.curated || _this.mod.tweets[i].curated) {
              are_there_new_tweets_to_show = true;
            }
          }
        }
        if (!are_there_new_tweets_to_show) {
          return;
        }
        if (_this.mod.out_of_order) {
          _this.hideLoader();
          if (!document.getElementById('saito-load-new-tweets')) {
            _this.app.browser.prependElementToSelector("<div class=\"saito-button-secondary saito-load-new-tweets\" id=\"saito-load-new-tweets\">load new tweets</div>", '.redsquare-load-new-tweets-container');
          }
          document.getElementById('saito-load-new-tweets').onclick = function (e) {
            _this.scrollFeed(0, 'smooth');
            e.currentTarget.remove();
            _this.clearFeed();
            _this.render();
            _this.mod.out_of_order = false;
          };
        } else {
          _this.render();
        }
        _this.mod.tweets_earliest_ts--;
      }
    });

    //
    // tweet
    //
    app.connection.on('redsquare-tweet-render-request', function (tweet) {
      if (_this.mode == 'tweet') {
        window.history.replaceState({
          view: 'tweet',
          tweet: tweet.thread_id
        }, null, '/' + _this.mod.slug + "/?tweet_id=".concat(tweet.tx.signature));
      } else {
        window.history.pushState({
          view: 'tweet',
          tweet: tweet.thread_id
        }, null, '/' + _this.mod.slug + "/?tweet_id=".concat(tweet.tx.signature));
      }
      _this.render();
    });

    //
    // notifications
    //
    app.connection.on('redsquare-notifications-render-request', function () {
      window.history.pushState({
        view: 'notifications',
        last_view: _this.notifications_last_viewed_ts,
        unviewed_ct: _this.mod.notifications_number_unviewed
      }, null, '/' + _this.mod.slug + '#notifications');
      _this.render();
    });

    //
    // profile
    //
    app.connection.on('redsquare-profile-render-request', function () {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!publicKey) {
        publicKey = _this.mod.publicKey;
      }
      var target = publicKey == _this.mod.publicKey ? '#profile' : "/?user_id=".concat(publicKey);
      window.history.pushState({
        view: 'profile',
        publicKey: publicKey
      }, '', '/' + _this.mod.slug + target);
      _this.render();
    });

    //
    // blacklist
    //
    app.connection.on('saito-blacklist', function (obj) {
      var target_key = obj === null || obj === void 0 ? void 0 : obj.publicKey;
      if (!target_key) {
        return;
      }
      var _iterator = _createForOfIteratorHelper(_this.mod.tweets),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tweet = _step.value;
          if (tweet.tx.isFrom(target_key)) {
            tweet.hideTweet();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });

    //////////////////////////////
    // load more on scroll-down //
    //////////////////////////////
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          document.getElementById('intersection-observer-trigger').classList.add('deactivated');
          _this.intersectionObserver.disconnect();
          _this.handleIntersection();
        }
      });
    }, {
      root: null,
      threshold: 1
    });

    //
    // INTERNAL NAVIGATION IN REDSQUARE
    //
    window.onpopstate = function (event) {
      if (_this.mod.debug) {
        console.info('===================', 'RS.NAV[onpopstate]: ', event === null || event === void 0 ? void 0 : event.state, window.location, '========================');
      }
      _this.render(event.state);
    };
  }
  return _createClass(RedSquareMain, [{
    key: "clearFeed",
    value: function clearFeed() {
      document.getElementById('intersection-observer-trigger').classList.add('deactivated');
      this.intersectionObserver.disconnect();
      var holder = document.getElementById('tweet-thread-holder');
      var managerElem = document.querySelector('.tweet-container');
      if (holder) {
        while (holder.hasChildNodes()) {
          holder.firstChild.remove();
        }
      }
      if (managerElem) {
        while (managerElem.hasChildNodes()) {
          managerElem.firstChild.remove();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var time = Date.now();
      if (!document.querySelector('.saito-container')) {
        this.app.browser.addElementToDom(RedSquareMainTemplate(this.mod));
      }
      var mainElem = document.querySelector('.tweet-container');
      var holderElem = document.querySelector('.tweet-thread-holder');
      if (!mainElem || !holderElem) {
        console.error('Error rendering RS Main');
        return;
      }
      this.attachEvents();
      mainElem.classList.remove('thread-view');

      //////////////////////
      // check url hash so we don't render conflicting things...
      //
      var new_mode = 'tweets';
      var user_id = this.app.browser.returnURLParameter('user_id');
      switch (window.location.hash) {
        case '#notifications':
          console.debug('RS.NAV: Render Notifications');
          new_mode = 'notifications';
          break;
        case '#profile':
          user_id = this.mod.publicKey;
          break;
        case '#bizarro':
          this.mod.bizarro = true;
        default:
      }

      //
      // render user profile
      //
      if (user_id) {
        new_mode = 'profile';
      }

      //
      // if view specific tweet, ask for tweet/children
      //
      var tweet_id = this.app.browser.returnURLParameter('tweet_id');
      if (tweet_id) {
        new_mode = 'tweet';
      }

      //
      // Keep sidebar highlight in sync with the current view
      //
      this.app.connection.emit('redsquare-clear-menu-highlighting', new_mode);

      //
      // turn off infinite scroll
      //
      document.getElementById('intersection-observer-trigger').classList.add('deactivated');
      this.intersectionObserver.disconnect();

      //
      // remove profile (if preesnt)
      //
      this.profile.remove();
      while (document.querySelector('.saito-end-of-redsquare')) {
        document.querySelector('.saito-end-of-redsquare').remove();
      }
      console.info('Render RS main for mode: ', new_mode, 'Current: ', this.mode);
      if (new_mode != this.mode) {
        // Return to curated view
        if (this.mod.curated) {
          document.querySelector('.tweet-container').classList.add('active-curation');
          if (document.querySelector('.show-more-button')) {
            document.querySelector('.show-more-button').remove();
          }
        }
      }
      try {
        document.querySelector('.saito-main').dataset.view = new_mode;
      } catch (err) {}

      //
      // return to / display main feed
      //
      if (new_mode === 'tweets') {
        if (this.mode !== 'tweets') {
          mainElem.replaceChildren.apply(mainElem, _toConsumableArray(holderElem.children));
        }
        var _iterator2 = _createForOfIteratorHelper(this.mod.tweets),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var tweet = _step2.value;
            if (!tweet.isRendered()) {
              tweet.renderWithCriticalChild();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        this.scrollFeed(this.scroll_depth, this.scroll_depth == 0 ? 'smooth' : 'auto');
        this.app.connection.emit('saito-header-reset-logo');
        this.mod.out_of_order = false;
        if (this.mode !== 'welcome') {
          this.enableObserver();
        }
        this.mode = new_mode;
        if (this.mod.debug) {
          console.debug("RS.render: ".concat(Date.now() - time, "ms elapsed in rendering main feed"));
        }
        return;
      }
      this.scrollFeed(0);

      //
      // backup tweets into hidden div before nevigating away from main thread
      // (this is to speed up navigation by keeping downloaded images in the browser)
      //
      if (this.mode === 'tweets') {
        holderElem.replaceChildren.apply(holderElem, _toConsumableArray(mainElem.children));
      }

      //
      // otherwise clear out any profile/notification list tweets
      //
      while (mainElem.hasChildNodes()) {
        mainElem.firstChild.remove();
      }

      // set back arrow
      if (window.history.state) {
        this.app.connection.emit('saito-header-replace-logo', function () {
          window.history.back();
        });
      } else {
        console.log('Rendering RS page direct from url');
        this.app.connection.emit('saito-header-replace-logo', function () {
          _this2.app.connection.emit('redsquare-home-render-request');
        });
      }
      //

      if (!this.mod.archive_connected) {
        console.warn('RS.Need to wait for archive so we can get stuff for RedSquare');
        return;
      }
      this.mode = new_mode;

      //
      // render notification
      //
      if (new_mode === 'notifications') {
        console.log('RS-main.render -- notifications: ', this.mod.notifications.length);
        if (this.mod.notifications.length > 0) {
          for (var i = 0; i < this.mod.notifications.length; i++) {
            var notification = new Notification(this.app, this.mod, this.mod.notifications[i]);
            notification.render('.tweet-container');
          }
        }
        this.mod.resetNotifications();
        this.moreNotifications();
        //this.enableObserver();

        console.debug("RS.render: ".concat(Date.now() - time, "ms elapsed in rendering notifications"));
        return;
      }

      //
      // render tweet (thread)
      //
      if (new_mode === 'tweet') {
        mainElem.classList.add('thread-view');
        var _tweet = this.mod.returnTweet(tweet_id);
        if (_tweet) {
          this.renderTweet(_tweet);
        } else {
          this.showLoader();
          console.debug('Resort to callback for tweet thread...');
          ///>>>>>>> We should load the whole thread here...
          this.mod.loadTweetThread(tweet_id, function (txs) {
            _this2.hideLoader();
            console.debug("RS.NAV: Tweet thread load returned ".concat(txs.length, " tweets"));
            var tweet = _this2.mod.returnTweet(tweet_id);
            _this2.renderTweet(tweet);
          });
        }
      }

      //
      // render profile
      //
      if (new_mode === 'profile') {
        //
        // There is no point viewing someone's profile and applying curation filtering...
        //
        if (document.querySelector('.active-curation')) {
          document.querySelector('.active-curation').classList.remove('active-curation');
        }
        if (user_id != this.profile.publicKey) {
          this.profile_tweets[this.profile.publicKey] = this.profile.menu;
          this.profile.reset(user_id, 'posts', this.profile_tabs);
          var _iterator3 = _createForOfIteratorHelper(this.mod.peers),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var peer = _step3.value;
              peer.profile_ts = new Date().getTime();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
        this.loader.show();
        if (this.profile_tweets[user_id]) {
          this.profile.menu = this.profile_tweets[user_id];
        }
        this.profile.render();
        this.loadProfile();
      }
      console.debug("RS.render: ".concat(Date.now() - time, "ms elapsed in rendering"));
    }
  }, {
    key: "moreNotifications",
    value: function moreNotifications() {
      var _this3 = this;
      this.showLoader();
      this.mod.loadNotifications(function (new_txs) {
        if (_this3.mode !== 'notifications') {
          return;
        }
        for (var i = 0; i < new_txs.length; i++) {
          var notification = new Notification(_this3.app, _this3.mod, new_txs[i]);
          notification.render('.tweet-container');
        }
        if (new_txs.length == 0) {
          if (_this3.mod.notifications.length == 0) {
            //Dummy "Notification" for end of history sign
            var _notification = new Notification(_this3.app, _this3.mod, null);
            _notification.render('.tweet-container');
          }
          setTimeout(function () {
            _this3.hideLoader();
          }, 50);
        } else {
          _this3.enableObserver();
        }
      });
    }

    /**
     *  I know how many tx this peer returned,
     *  whether there are 0, 1, or more active peers,
     *  and the earliest tweet time stamps (system and this peer)
     */
  }, {
    key: "insertOlderTweets",
    value: function insertOlderTweets(tx_count) {
      var peer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      console.debug('Infinite Scroll callback: ', peer.publicKey.substring(0, 10), tx_count, this.numActivePeers, this.mod.tweets_earliest_ts);
      if (this.mode !== 'tweets') {
        return;
      }

      // Render
      var _iterator4 = _createForOfIteratorHelper(this.mod.tweets),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var tweet = _step4.value;
          if (!tweet.isRendered()) {
            tweet.renderWithCriticalChild();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.numActivePeers--;
      if (this.numActivePeers <= 0) {
        console.debug('RS.insertOlderTweets -- all active peers returned: ', tx_count);
        this.enableObserver();
      } else {
        console.debug('RS.insertOlderTweets -- still waiting on a peer to return');
      }
    }

    //
    // fetch profile tweets as needed
    //
  }, {
    key: "loadProfile",
    value: function () {
      var _loadProfile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this4 = this;
        var profile_id, np, _iterator5, _step5, _loop, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              profile_id = this.profile.publicKey;
              if (this.mod.publicKey == profile_id) {
                console.debug('RS.Profile -- use list of liked tweets');
                // Find likes...
                // I already have a list of tweets I liked available
                this.loadProfileLikes(this.mod.liked_tweets, 'localhost');
              }
              np = this.mod.peers.length;
              if (np > 1) {
                siteMessage("Checking with ".concat(np, " peers for profile tweets..."), 1000);
              } else {
                this.showLoader();
              }
              _iterator5 = _createForOfIteratorHelper(this.mod.peers);
              _context2.p = 1;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var peer;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      peer = _step5.value;
                      if (_this4.mod.publicKey !== profile_id && peer.peer !== 'localhost') {
                        console.debug('RS.Profile -- query peer for likes ', peer.publicKey.substring(0, 10));
                        _this4.app.storage.loadTransactions({
                          field1: 'RedSquareLike',
                          field2: profile_id,
                          limit: 100
                        }, function (txs) {
                          var liked_tweets = [];
                          var _iterator6 = _createForOfIteratorHelper(txs),
                            _step6;
                          try {
                            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                              var _txmsg$data;
                              tx = _step6.value;
                              var txmsg = tx.returnMessage();
                              var sig = txmsg === null || txmsg === void 0 || (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.signature;
                              if (sig && !liked_tweets.includes(sig)) {
                                liked_tweets.push(sig);
                              }
                            }
                          } catch (err) {
                            _iterator6.e(err);
                          } finally {
                            _iterator6.f();
                          }
                          _this4.loadProfileLikes(liked_tweets, peer);
                        }, peer);
                      }
                      console.debug('RS.Profile -- query peer for tweets: ', peer.publicKey.substring(0, 10));
                      _this4.app.storage.loadTransactions({
                        field1: 'RedSquare',
                        field2: profile_id,
                        limit: 100,
                        created_earlier_than: peer.profile_ts
                      }, function (txs) {
                        _this4.hideLoader();

                        // Sort txs into posts/replies/retweets...
                        _this4.filterProfileTweets(txs, profile_id);

                        //
                        // Don't use processTweetsFromPeer(peer, txs)
                        // because it updates the global timestamps and caches tweets in our local storage
                        //
                        for (var z = 0; z < txs.length; z++) {
                          var _txs$z;
                          txs[z].decryptMessage(_this4.app);
                          //this.mod.addTweet(txs[z], {type: "profile", node: peer.publicKey});
                          peer.profile_ts = (_txs$z = txs[z]) === null || _txs$z === void 0 ? void 0 : _txs$z.timestamp;
                        }
                        if (_this4.mode !== 'profile' || profile_id !== _this4.profile.publicKey) {
                          console.warn("Navigated away from profile before peer (".concat(peer === null || peer === void 0 ? void 0 : peer.publicKey, ") returned results..."));
                          return;
                        }
                        console.debug("RS.Profile -- rendering profile with results (".concat(txs.length, ") from peer (").concat(peer.publicKey.substring(0, 10), ")"));
                        _this4.profile.render();
                        if (txs.length == 100) {
                          _this4.enableObserver();
                        }
                        if (peer.peer !== 'localhost') {
                          siteMessage("Processing response from ".concat(_this4.app.keychain.returnUsername(peer.publicKey)), 1000);
                        }
                        np--;
                        setTimeout(function () {
                          if (np > 0) {
                            siteMessage("Loading from ".concat(np, " peers..."), 1000);
                          }
                        }, 1500);
                      }, peer.peer);
                    case 1:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _iterator5.s();
            case 2:
              if ((_step5 = _iterator5.n()).done) {
                _context2.n = 4;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 3);
            case 3:
              _context2.n = 2;
              break;
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              _iterator5.e(_t);
            case 6:
              _context2.p = 6;
              _iterator5.f();
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee, this, [[1, 5, 6, 7]]);
      }));
      function loadProfile() {
        return _loadProfile.apply(this, arguments);
      }
      return loadProfile;
    }()
  }, {
    key: "loadProfileLikes",
    value: function loadProfileLikes(list_of_liked_tweet_sigs, peer) {
      var _this5 = this;
      if (this.mode !== 'profile') {
        return;
      }
      var _iterator7 = _createForOfIteratorHelper(list_of_liked_tweet_sigs),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var sig = _step7.value;
          //
          // We may already have the liked tweet in memory
          //
          var old_tweet = this.mod.returnTweet(sig);
          if (old_tweet) {
            this.insertTweetIntoList(old_tweet, this.profile.menu.likes);
            this.app.connection.emit('update-profile-stats', 'likes', list_of_liked_tweet_sigs.length);
          } else {
            //
            // Otherwise, we gotta hit up the archive
            //
            console.log('RS.Profile -- pull liked tweet from archive...');
            this.app.storage.loadTransactions({
              field1: 'RedSquare',
              sig: sig
            }, function (txs) {
              for (var z = 0; z < txs.length; z++) {
                var tweet = new Tweet(_this5.app, _this5.mod, txs[z]);
                _this5.insertTweetIntoList(tweet, _this5.profile.menu.likes);
              }
              _this5.app.connection.emit('update-profile-stats', 'likes', list_of_liked_tweet_sigs.length);
            }, peer);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "insertTweetIntoList",
    value: function insertTweetIntoList(tweet, list) {
      var insertion_index = 0;
      for (var i = 0; i < list.length; i++) {
        if (list[i].tx.signature === tweet.tx.signature) {
          return;
        }
        if (tweet.created_at > list[i].created_at) {
          break;
        } else {
          insertion_index++;
        }
      }
      list.splice(insertion_index, 0, tweet);
    }
  }, {
    key: "filterProfileTweets",
    value: function filterProfileTweets(txs, user_id) {
      var profile_lists = user_id === this.profile.publicKey ? this.profile.menu : this.profile_tweets[user_id];
      for (var z = 0; z < txs.length; z++) {
        var tweet = new Tweet(this.app, this.mod, txs[z]);
        if (tweet !== null && tweet !== void 0 && tweet.noerrors) {
          if (tweet.isRetweet()) {
            this.insertTweetIntoList(tweet, profile_lists.retweets);
            return;
          }
          if (tweet.isPost()) {
            this.insertTweetIntoList(tweet, profile_lists.posts);
          }
          if (tweet.isReply()) {
            this.insertTweetIntoList(tweet, profile_lists.replies);
          }
        }
      }
      var str = '';
      for (var key in profile_lists) {
        str += "".concat(key, ": ").concat(profile_lists[key].length, ", ");
      }
      console.debug('RS.Profile -- ', user_id.substring(0, 10), this.profile.publicKey.substring(0, 10), str);
    }

    //
    // this renders a tweet, loads all of its available children and adds them to the page
    // as they appear...
    //
  }, {
    key: "renderTweet",
    value: function renderTweet(tweet) {
      var _this6 = this;
      //
      // make sure visible
      //
      tweet.curated = 1;
      tweet.force_long_tweet = true;
      if (this.mod.debug) {
        console.debug('RS.renderTweet --', tweet.tx.signature, tweet.parent_id, tweet.thread_id, this.thread_id);
      }
      //
      // get thread id
      //
      var thread_id = tweet.thread_id || tweet.parent_id || tweet.tx.signature;

      //
      // remove tweets - TODO holder
      //
      document.querySelector('.tweet-container').innerHTML = '';
      var markHighlightedTweet = function markHighlightedTweet() {
        if (document.querySelector(".tweet-".concat(tweet.tx.signature))) {
          document.querySelector(".tweet-".concat(tweet.tx.signature)).classList.add('highlight-tweet');
          if (_this6.mod.curated) {
            Array.from(document.querySelectorAll('.tweet-container > .tweet')).forEach(function (t) {
              if (window.getComputedStyle(t).display != 'grid') {
                console.warn('hidden comment!!!');
                console.log(t, window.getComputedStyle(t).display);
                if (!document.querySelector('.show-more-button')) {
                  _this6.app.browser.addElementAfterSelector("<div class=\"show-more-button saito-button-secondary\">show hidden comments</div>", '.tweet-container');
                  document.querySelector('.show-more-button').onclick = function (e) {
                    if (document.querySelector('.tweet-container')) {
                      document.querySelector('.tweet-container').classList.remove('active-curation');
                    }
                  };
                }
              }
            });
          }
        }
      };
      this.thread_id = thread_id;
      if (!tweet.thread_sigs) {
        tweet.thread_sigs = this.mod.returnThreadSigs(tweet.tx.signature);
      }

      //
      // show our tweet
      //
      var root_tweet = this.mod.returnTweet(thread_id);
      if (!(root_tweet !== null && root_tweet !== void 0 && root_tweet.isLoaded())) {
        this.showLoader();
        siteMessage('Querying full thread...', 2000);
        console.log('RS.Load thread... in 500ms');

        //
        // We set a timeout so that loading by url gives the peer connections a second to get established before requesting the full thread
        // We should investigate why sendRequestAsTransaction() has a disconnect between the returned results and what the callback sees
        // when we perform this request synchronously
        // loadTransactions() -> [storage] network.sendRequestAsTransaction -> archive -- hits an error in [storage] internal_callback
        //
        setTimeout(this.mod.loadTweetThread.bind(this.mod), 500, thread_id, function () {
          console.log('RS...callback -- ', thread_id);
          //
          // This will catch you navigating back to the main feed before the callback completes
          //
          if (_this6.mode === 'tweet' && _this6.thread_id === thread_id) {
            var _root_tweet = _this6.mod.returnTweet(thread_id);
            if (_root_tweet) {
              _root_tweet.renderWithChildrenWithTweet(tweet, tweet.thread_sigs);
            } else {
              console.warn('Root tweet not found...');
            }
            markHighlightedTweet();
          } else {
            console.info('RS.load thread returned... opt out of rendering');
          }
          _this6.hideLoader();
        });
      } else {
        root_tweet.renderWithChildrenWithTweet(tweet, tweet.thread_sigs);
        markHighlightedTweet();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      if (this.events_attached) {
        return;
      }

      /* Scroll the right side bar code (originally in ./sidebar.js) */
      var scrollableElement = document.querySelector('.saito-container');
      var sidebar = document.querySelector('.saito-sidebar.right');
      var scrollTop = 0;
      var stop = 0;
      scrollableElement.addEventListener('scroll', function (e) {
        var newScrollTop = scrollableElement.scrollTop;
        var maxScroll = sidebar.clientHeight - window.innerHeight + 70;
        if (maxScroll > 0) {
          if (scrollTop < newScrollTop) {
            if (newScrollTop - stop > maxScroll) {
              stop = window.innerHeight - 70 - sidebar.clientHeight + newScrollTop;
            }
          } else {
            if (stop > newScrollTop) {
              stop = newScrollTop;
            }
          }
        } else {
          //Keep top of side bar fixed relative to viewPort
          stop = newScrollTop;
        }
        sidebar.style.top = stop + 'px';
        scrollTop = newScrollTop;
      });

      /* Code for the slide-out header */
      /*
      var scrollableElement = document.querySelector('.saito-container');
       let lastScrollTop = 0;
      let triggered = false;
      let is_running = false;
       if (this.app.browser.isSupportedBrowser()) {
        let hh = getComputedStyle(document.body).getPropertyValue('--saito-header-height');
         scrollableElement.addEventListener('scroll', (e) => {
          var st = scrollableElement.scrollTop;
           if (is_running) {
            return;
          }
           is_running = true;
           if (st > lastScrollTop) {
            if (!triggered) {
              document.getElementById('saito-header').style.top = `-${hh}`;
              document.getElementById('saito-header').style.height = '0';
              document.getElementById('saito-header').style.padding = '0';
              document.querySelector('.saito-container').classList.add('scrolling');
              document.querySelector('.saito-sidebar.left').classList.add('scrolling');
              triggered = true;
            }
             is_running = 'down';
          } else if (st < lastScrollTop) {
            if (triggered) {
              document.getElementById('saito-header').removeAttribute('style');
              document.querySelector('.saito-container').classList.remove('scrolling');
              document.querySelector('.saito-sidebar.left').classList.remove('scrolling');
              triggered = false;
            }
          }
           lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
           if (this.mode == 'tweets') {
            this.scroll_depth = scrollableElement.scrollTop;
          }
           setTimeout(() => {
            is_running = false;
            if (scrollableElement.scrollTop < 50 && triggered) {
              document.getElementById('saito-header').removeAttribute('style');
              document.querySelector('.saito-container').classList.remove('scrolling');
              document.querySelector('.saito-sidebar.left').classList.remove('scrolling');
              triggered = false;
            }
          }, 75);
        });
      }*/

      this.events_attached = true;
    }
  }, {
    key: "scrollFeed",
    value: function scrollFeed() {
      var newDepth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scroll_depth;
      var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
      var elem = document.querySelector('.saito-container');
      if (this.mode === 'tweets') {
        this.scroll_depth = elem.scrollTop;
        //console.info('Cache scroll depth of RS Feed -- ', this.scroll_depth);
      }
      //console.info('Scroll RS tweet container to : ', newDepth);
      elem.scroll({
        top: newDepth,
        left: 0,
        behavior: behavior
      });
    }
  }, {
    key: "enableObserver",
    value: function enableObserver() {
      //
      // dynamic content loading
      //
      this.hideLoader();
      var ob = document.getElementById('intersection-observer-trigger');
      if (ob) {
        if (ob.classList.contains('deactivated')) {
          ob.classList.remove('deactivated');
          if (ob.getBoundingClientRect().top <= 0) {
            //console.debug('RS.Observer out of bounds...', ob.getBoundingClientRect().top);
            this.handleIntersection();
          } else {
            //console.debug('Turn on observer', ob.getBoundingClientRect().top);
            this.intersectionObserver.observe(ob);
          }
        }
      }
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection() {
      if (this.mode === 'tweet' || this.mode == 'loading') {
        return;
      }
      console.debug('RS.IntersectionObserver triggered! ', this.mode);

      //
      // load more tweets -- from local and remote sources
      //
      if (this.mode === 'tweets') {
        this.showLoader("".concat(this.mod.tweets.length, " tweets in the feed, loading more..."));
        this.numActivePeers = this.mod.loadTweets('earlier', this.insertOlderTweets.bind(this));
        if (!this.numActivePeers) {
          console.log('RS.handleIntersection -- smack box on the side');
          this.mod.tweets_earliest_ts--;
          this.numActivePeers = this.mod.loadTweets('earlier', this.insertOlderTweets.bind(this));
          if (!this.numActivePeers) {
            console.debug('RS.insertOlderTweets: END of REDSQUARE !!!!', this.mod.tweets_earliest_ts, this.mod.peers);
            this.hideLoader();
            if (!document.querySelector('.saito-end-of-redsquare')) {
              this.app.browser.addElementAfterSelector("<div class=\"saito-end-of-redsquare\">no more tweets</div>", '.tweet-container');
            }
          }
        }
        return;
      }
      this.showLoader();

      //
      // load more notifications
      //
      if (this.mode === 'notifications') {
        this.moreNotifications();
      }

      /////////////////////////////////////////////////
      //
      // So right now, we are fetching earlier stuff from the intersection observer
      // We will fetch the 100 most recent tweets/likes, so we'll see if people start complaining
      // about not having enough history available
      //
      //////////////////////////////////////////////////

      if (this.mode === 'profile') {
        this.loadProfile();
      }
    }
  }, {
    key: "showLoader",
    value: function showLoader() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.loader.show(msg);
    }
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      this.loader.remove(0);
    }
  }]);
}();
module.exports = RedSquareMain;